import { isVersionUK, isVersionUS } from "./versionService";

export const MSAL_AUTHORITY_UK = "https://kihuk.ciamlogin.com/844776c2-e82d-4d3d-b125-95b3db2e2022";
export const MSAL_AUTHORITY_US = "https://gouspa.ciamlogin.com/02ce1eb6-67cd-4995-be12-45c76dce4a4e";
const CLIENT_ID_UK_DEV = "15241e28-b887-42df-9920-c4a9bb36b443";
const CLIENT_ID_US_DEV = "09082b14-8568-4d71-9444-37553cc1240c";
const CLIENT_ID_UK_PROD = "d77edf3c-69d8-47d2-a295-07f612948563";
const CLIENT_ID_US_PROD = "d4851fb0-aeac-469c-8ffb-fbbed287fc0d";

export const DEV_UK_API_DOMAIN = "https://api-test.kingsinterhigh.co.uk";
export const DEV_US_API_DOMAIN = "https://api-usa-test.kingsinterhigh.com";
export const PROD_UK_API_DOMAIN = "https://api-uk1.kingsinterhigh.co.uk";
export const PROD_US_API_DOMAIN = "https://api-usa1.gouspa.org";

const LOCAL_DOMAINS = ["localhost"];
const DEV_UK_DOMAINS = ["dev-parent.kingsinterhigh.co.uk"];
const DEV_US_DOMAINS = ["dev-parent.kingsinterhigh.com"];
const PROD_UK_DOMAINS = ["parenthub.kingsinterhigh.co.uk"];
const PROD_US_DOMAINS = ["parenthub.gouspa.org"];

const host = window.location.hostname.toLowerCase();

export const isLocal = LOCAL_DOMAINS.find((domain) => host === domain);
export const isUKDevelopment = DEV_UK_DOMAINS.find((domain) => host === domain);
export const isUSDevelopment = DEV_US_DOMAINS.find((domain) => host === domain);
export const isUKProduction = PROD_UK_DOMAINS.find((domain) => host === domain);
export const isUSProduction = PROD_US_DOMAINS.find((domain) => host === domain);
export const isProduction = isUKProduction || isUSProduction;

const isUK = isUKDevelopment || isUKProduction;
const isUS = isUSDevelopment || isUSProduction;

export const CLIENT_ID = (isUK || isVersionUK)
    ? isUKProduction
        ? CLIENT_ID_UK_PROD
        : CLIENT_ID_UK_DEV
    : isUSProduction
        ? CLIENT_ID_US_PROD
        : CLIENT_ID_US_DEV;
export const IH_ACCESS_SCOPE = `api://${CLIENT_ID}/access_as_ih_user`;

export const getApiDomain = (useDevelopment) => {
    if ((isLocal && isVersionUK) || useDevelopment) return DEV_UK_API_DOMAIN;
    if ((isLocal && isVersionUS)) return DEV_US_API_DOMAIN;

    if (isUKDevelopment) return DEV_UK_API_DOMAIN;
    if (isUSDevelopment) return DEV_US_API_DOMAIN;
    if (isUKProduction) return PROD_UK_API_DOMAIN;
    if (isUSProduction) return PROD_US_API_DOMAIN;

    return "";
};
